import React from 'react';

import { Snackbar, makeStyles } from '@material-ui/core';

import Button from 'bz-core-controls/controls/general/button';
import useInterval from 'lib/hooks/useInterval';

const VersionCheck = () => {
  const [open, setOpen] = React.useState(false);

  useInterval(async () => {
    if (process.env.Version?.includes('undefined') || process.env.Version === undefined) return;
    const res = await fetch('/version.json', { cache: 'reload' });
    const data = await res.json();
    //console.log(`version-check: ${data.Version} ${process.env.Version}`);
    if (data.Version != process.env.Version) {
      setOpen(true);
    }
  }, 60000);

  return <Snackbar open={open} message={<SnackContent version={process.env.Version} />} />;
};

const useStyles = makeStyles({
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    gridColumnGap: '1em',
    alignItems: 'center'
  }
});

const SnackContent = (): JSX.Element => {
  const classes = useStyles();

  const onClick = () => {
    window.location.reload();
  };

  return (
    <div className={classes.container}>
      <span>New version available</span>
      <Button primary={true} onClick={() => onClick()}>
        Refresh Page
      </Button>
    </div>
  );
};

export default VersionCheck;
